import { render, staticRenderFns } from "./LogsComp.vue?vue&type=template&id=d6d8a80e&scoped=true&"
import script from "./LogsComp.vue?vue&type=script&lang=js&"
export * from "./LogsComp.vue?vue&type=script&lang=js&"
import style0 from "./LogsComp.vue?vue&type=style&index=0&id=d6d8a80e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d8a80e",
  null
  
)

export default component.exports